import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  return <Section background="white" data-id="element-237">
      <div className="text-center mb-16" data-id="element-238">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4" data-id="element-239">
          Ellas ya dominaron el arte
        </h2>
        <div className="flex justify-center gap-1" data-id="element-240">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500" data-id="element-241" />)}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-242">
        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-243">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-244">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-245">
            Vivo en Miami y la humedad siempre arruinaba mis postres. Hice el
            Mil Hojas para el cumpleaños de mi suegra y{' '}
            <span className="font-bold text-stone-900" data-id="element-246">
              se mantuvo crujiente por 2 días
            </span>
            . ¡No lo podía creer!
          </p>
          <div className="flex items-center gap-4" data-id="element-247">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-248">
              C
            </div>
            <div data-id="element-249">
              <p className="font-bold text-stone-900" data-id="element-250">Carolina M.</p>
              <p className="text-sm text-stone-500" data-id="element-251">Miami, FL</p>
            </div>
          </div>
        </div>

        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-252">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-253">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-254">
            Siempre me daba vergüenza llevar postres porque llegaban feos. Con
            esta técnica, el corte salió perfecto.{' '}
            <span className="font-bold text-stone-900" data-id="element-255">
              Mis amigas pensaron que lo compré en una pastelería francesa.
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-256">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-257">
              S
            </div>
            <div data-id="element-258">
              <p className="font-bold text-stone-900" data-id="element-259">Sofia R.</p>
              <p className="text-sm text-stone-500" data-id="element-260">Houston, TX</p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}